// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.na6A6rfY5_XXN1Hl44vW {
  position: relative;
  height: 100%;
}

.T94Od5s3Gq9HGnO1_XUM {
  padding: 1.5rem 0 7.25rem;
  height: 100%;
}

.mpsKnmDc9DmE3VvBZyYv {
  margin-bottom: 1.5rem;
}

.JrexWwkOAhUfRqp8LHIQ {
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 0.0625rem solid var(--grey-200);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 0;
  margin: 0 auto;
  width: 100%;
}

.vRyJFmR0MpRc4HwrYuXg {
  font-size: 1rem;
  margin-right: 0.9375rem;
}

.O1YFkUfLvs3g7BnCQxYj {
  min-width: 8.375rem;
  font-size: 0.9375rem;
}

.Hm9jTOi7JYe6owgn_FLn {
  margin-bottom: 1.5rem;
}

.e5pGOpPYmA6tKtok77Pl {
  display: block;
  margin-bottom: 1rem;
}

.yuA2PBwYVzqd7tXbqVsk:disabled {
    color: var(--grey-80)
  }

.yuA2PBwYVzqd7tXbqVsk:disabled:focus,
    .yuA2PBwYVzqd7tXbqVsk:disabled:hover {
      border-color: var(--grey-200);
    }

.iXWIx8eAEZHHSZenWZ2Q {
  display: flex;
  align-items: center;
}

.rehArGFVt9RzriKCukzP {
  margin-right: 0.5rem;
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .T94Od5s3Gq9HGnO1_XUM {
    padding: 1rem 1.5rem 5.1875rem;
  }

  .mpsKnmDc9DmE3VvBZyYv {
    position: relative;
    left: -1.5rem;
    width: calc(100% + 3rem);
    padding: 0 1.5rem 1rem;
    margin-bottom: 1.5rem;
    border-bottom: 0.0625rem solid var(--grey-200);
  }

  .JrexWwkOAhUfRqp8LHIQ {
    padding: 1rem 0;
    margin: 0 1.5rem;
    width: calc(100% - 3rem);
  }
}

@media only screen and
  (max-width: 639px) {
  .T94Od5s3Gq9HGnO1_XUM {
    padding: 0;
    top: -2.25rem;
  }

  .mpsKnmDc9DmE3VvBZyYv {
    position: relative;
    left: -1rem;
    width: calc(100% + 2rem);
    padding: 0 2.625rem 1rem 1rem;
    margin-bottom: 1.5rem;
    border-bottom: 0.0625rem solid var(--grey-200);
  }

  .JrexWwkOAhUfRqp8LHIQ {
    padding: 1rem 0 2rem;
    margin: 0 1rem;
    width: calc(100% - 2rem);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LanguageForm/LanguageForm.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,qBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,2CAAqC;EACrC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,eAAe;EACf,uBAAkB;AACpB;;AAEA;EACE,mBAAgB;EAChB,oBAAe;AACjB;;AAEA;EACE,qBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAGE;IACE;EAMF;;AAJE;;MAEE,6BAA6B;IAC/B;;AAIJ;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAiB;AACnB;;AAEA;;;EACE;IACE,8BAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,aAAW;IACX,wBAAwB;IACxB,sBAAoB;IACpB,qBAAmB;IACnB,8CAAwC;EAC1C;;EAEA;IACE,eAAe;IACf,gBAAc;IACd,wBAAwB;EAC1B;AACF;;AAEA;;EACE;IACE,UAAU;IACV,aAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,wBAAwB;IACxB,6BAAyB;IACzB,qBAAmB;IACnB,8CAAwC;EAC1C;;EAEA;IACE,oBAAoB;IACpB,cAAc;IACd,wBAAwB;EAC1B;AACF","sourcesContent":[".languageForm {\n  position: relative;\n  height: 100%;\n}\n\n.languageFormContent {\n  padding: 24px 0 116px;\n  height: 100%;\n}\n\n.languageFormTitle {\n  margin-bottom: 24px;\n}\n\n.languageFormFooter {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  border-top: 1px solid var(--grey-200);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 0;\n  margin: 0 auto;\n  width: 100%;\n}\n\n.languageFormCancelButton {\n  font-size: 16px;\n  margin-right: 15px;\n}\n\n.languageFormApplyButton {\n  min-width: 134px;\n  font-size: 15px;\n}\n\n.inputWrapper {\n  margin-bottom: 24px;\n}\n\n.inputLabel {\n  display: block;\n  margin-bottom: 16px;\n}\n\n.inputField {\n  &:disabled {\n    color: var(--grey-80);\n\n    &:focus,\n    &:hover {\n      border-color: var(--grey-200);\n    }\n  }\n}\n\n.backButtonContent {\n  display: flex;\n  align-items: center;\n}\n\n.icon {\n  margin-right: 8px;\n}\n\n@media (--tablet) {\n  .languageFormContent {\n    padding: 16px 24px 83px;\n  }\n\n  .languageFormTitle {\n    position: relative;\n    left: -24px;\n    width: calc(100% + 48px);\n    padding: 0 24px 16px;\n    margin-bottom: 24px;\n    border-bottom: 1px solid var(--grey-200);\n  }\n\n  .languageFormFooter {\n    padding: 16px 0;\n    margin: 0 24px;\n    width: calc(100% - 48px);\n  }\n}\n\n@media (--mobile) {\n  .languageFormContent {\n    padding: 0;\n    top: -36px;\n  }\n\n  .languageFormTitle {\n    position: relative;\n    left: -16px;\n    width: calc(100% + 32px);\n    padding: 0 42px 16px 16px;\n    margin-bottom: 24px;\n    border-bottom: 1px solid var(--grey-200);\n  }\n\n  .languageFormFooter {\n    padding: 16px 0 32px;\n    margin: 0 16px;\n    width: calc(100% - 32px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"languageForm": `na6A6rfY5_XXN1Hl44vW`,
	"languageFormContent": `T94Od5s3Gq9HGnO1_XUM`,
	"languageFormTitle": `mpsKnmDc9DmE3VvBZyYv`,
	"languageFormFooter": `JrexWwkOAhUfRqp8LHIQ`,
	"languageFormCancelButton": `vRyJFmR0MpRc4HwrYuXg`,
	"languageFormApplyButton": `O1YFkUfLvs3g7BnCQxYj`,
	"inputWrapper": `Hm9jTOi7JYe6owgn_FLn`,
	"inputLabel": `e5pGOpPYmA6tKtok77Pl`,
	"inputField": `yuA2PBwYVzqd7tXbqVsk`,
	"backButtonContent": `iXWIx8eAEZHHSZenWZ2Q`,
	"icon": `rehArGFVt9RzriKCukzP`
};
export default ___CSS_LOADER_EXPORT___;
